module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "ushk-main ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-report"
  }, [_c('div', {
    staticClass: "ushk-report__h"
  }, [_c('jin-tabs', {
    staticClass: "ushk-report-tab",
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, [_c('jin-tab-pane', {
    attrs: {
      "label": "美股目标价",
      "name": "us"
    }
  }, [_c('report-content', {
    attrs: {
      "type": "us"
    },
    on: {
      "show-report": _vm.showReport
    }
  })], 1), _vm._v(" "), _c('jin-tab-pane', {
    attrs: {
      "label": "港股目标价",
      "name": "hk"
    }
  }, [(_vm.initHkTab) ? _c('report-content', {
    attrs: {
      "type": "hk"
    },
    on: {
      "show-report": _vm.showReport
    }
  }) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap"
  }, [_c('ad', {
    attrs: {
      "paddingTop": false
    }
  }), _vm._v(" "), _c('Declatration'), _vm._v(" "), _c('contract')], 1)]), _vm._v(" "), (_vm.curData) ? _c('report-dialog', {
    attrs: {
      "data": _vm.curData,
      "type": _vm.curType
    },
    model: {
      value: (_vm.isShowDialog),
      callback: function($$v) {
        _vm.isShowDialog = $$v
      },
      expression: "isShowDialog"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2479c3ec","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/pages/home.vue
// module id = yMad
// module chunks = 6